import * as tslib_1 from "tslib";
import { EntityNode } from "./EntityNode";
/**
 * @class away.partition.CameraNode
 */
var CameraNode = (function (_super) {
    tslib_1.__extends(CameraNode, _super);
    function CameraNode() {
        return _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    CameraNode.prototype.acceptTraverser = function (traverser) {
        // todo: dead end for now, if it has a debug sprite, then sure accept that
    };
    return CameraNode;
}(EntityNode));
export { CameraNode };



// WEBPACK FOOTER //
// ../dist/lib/partition/CameraNode.js